import { useLingui } from '@lingui/react/macro'
import { Button } from 'designSystem/components/Button'
import { ArrowUp, ListPlus, Square } from 'lucide-react'
import React from 'react'

export function DocChatComposerActionButton({
  disabled,
  isStopAction,
  isQueueAction = false,
  onClick,
  submitAriaLabel,
}: {
  disabled: boolean
  isStopAction: boolean
  isQueueAction?: boolean
  onClick: () => void
  submitAriaLabel: string
}): React.ReactElement {
  const { t } = useLingui()

  return (
    <Button
      variant={isStopAction ? 'outline' : 'default'}
      size='icon'
      shape='round'
      iconSize={isStopAction ? 'sm' : 'default'}
      type='button'
      aria-label={isStopAction ? t`Stop generating` : submitAriaLabel}
      title={isStopAction ? t`Stop generating` : submitAriaLabel}
      disabled={disabled}
      onClick={onClick}>
      {isStopAction ? (
        <Square fill='currentColor' />
      ) : isQueueAction ? (
        <ListPlus />
      ) : (
        <ArrowUp />
      )}
    </Button>
  )
}
